import { Link } from "react-router-dom";
import { Phone, MapPin, Facebook, Instagram, Youtube, Star } from "lucide-react";
import { BUSINESS, SERVICES, SOCIALS } from "../data/site";

const SOCIAL_ICONS = { Facebook, Instagram, YouTube: Youtube, "Find us on Google": Star };

export const Footer = () => (
    <footer data-testid="site-footer" className="bg-forest-night text-bone">
        <div className="mx-auto grid max-w-6xl gap-10 px-6 py-16 md:grid-cols-4">
            <div className="md:col-span-2">
                <div className="flex items-center gap-3">
                    <img src="/assets/photos/logo.png" alt="Lawn Busters — Professional Yard Care"
                        className="h-14 w-auto" />
                </div>
                <p className="mt-4 max-w-sm text-sm leading-relaxed text-bone/70">
                    Locally owned and operated in Adelaide. Professional lawn care, gutter &amp; window
                    cleaning, and junk removal for homes and properties across Adelaide.
                </p>
                <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.22em] text-ochre">
                    Proudly servicing Adelaide and surrounding suburbs
                </p>
                <div className="mt-6 flex flex-wrap items-center gap-3">
                    {SOCIALS.map((s) => {
                        const Icon = SOCIAL_ICONS[s.name];
                        return (
                            <a key={s.name} href={s.url} target="_blank" rel="noopener noreferrer" data-testid={s.testid}
                                aria-label={s.name}
                                className="flex h-10 w-10 items-center justify-center rounded-full border border-bone/20 text-bone/80 transition-colors hover:border-ochre hover:bg-ochre hover:text-forest-night">
                                <Icon size={16} />
                            </a>
                        );
                    })}
                    <a href={SOCIALS[3].url} target="_blank" rel="noopener noreferrer" data-testid="footer-review-cta"
                        className="ml-1 flex items-center gap-1.5 text-xs font-bold text-bone/80 transition-colors hover:text-ochre">
                        <Star size={13} className="text-ochre" /> Leave us a Google review
                    </a>
                </div>
            </div>
            <div>
                <p className="eyebrow text-bone/60">Services</p>
                <ul className="mt-4 space-y-2 text-sm">
                    {SERVICES.map((s) => (
                        <li key={s.slug}>
                            <Link to={s.path} data-testid={`footer-${s.slug}-link`} className="text-bone/80 transition-colors hover:text-ochre">
                                {s.name}
                            </Link>
                        </li>
                    ))}
                    <li><Link to="/before-after" data-testid="footer-before-after-link" className="text-bone/80 transition-colors hover:text-ochre">Before &amp; After</Link></li>
                    <li><Link to="/pricing" data-testid="footer-pricing-link" className="text-bone/80 transition-colors hover:text-ochre">Pricing</Link></li>
                    <li><Link to="/areas" data-testid="footer-areas-link" className="text-bone/80 transition-colors hover:text-ochre">Areas We Service</Link></li>
                </ul>
            </div>
            <div>
                <p className="eyebrow text-bone/60">Contact</p>
                <a href={BUSINESS.phoneHref} data-testid="footer-phone-link"
                    className="mt-4 flex items-center gap-2 text-sm font-semibold text-bone transition-colors hover:text-ochre">
                    <Phone size={14} /> {BUSINESS.phone}
                </a>
                <p className="mt-3 flex items-center gap-2 text-sm text-bone/70">
                    <MapPin size={14} /> {BUSINESS.city}
                </p>
                <div className="mt-4 space-y-2">
                    {SOCIALS.map((s) => {
                        const Icon = SOCIAL_ICONS[s.name];
                        return (
                            <a key={s.name} href={s.url} target="_blank" rel="noopener noreferrer" data-testid={`footer-contact-${s.testid}`}
                                className="flex items-center gap-2 text-sm text-bone/80 transition-colors hover:text-ochre">
                                <Icon size={14} /> {s.name}
                            </a>
                        );
                    })}
                </div>
                <Link to="/book-now" data-testid="footer-book-button"
                    className="mt-5 inline-block rounded-full bg-ochre px-5 py-2.5 text-sm font-bold text-forest-night transition-colors hover:bg-bone">
                    Book a Service
                </Link>
            </div>
        </div>
        <div className="border-t border-bone/10 py-5 text-center font-mono text-[10px] uppercase tracking-[0.2em] text-bone/50">
            Your local Adelaide property care team — Lawn Busters
        </div>
    </footer>
);
